import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { SubscriptionStatus } from '@constants/global';
import { UserService } from '@services/user.service';
import { UtilityService } from '@services/utility.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionGuard implements CanActivate {
  constructor(private user: UserService, private router: Router, private utility: UtilityService){}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      const isAccountDeactivated = (this.user.getUserInfo().userInfo && (this.user.getUserInfo().userInfo?.subscription_status !== SubscriptionStatus.ACTIVE && this.user.getUserInfo().userInfo?.subscription_status !== SubscriptionStatus.PAUSED)) ? true : false;

      if(!isAccountDeactivated){
        return true;
      }else{
        this.router.navigate(['/change-subscription']);
        return false;
      }
  }
  
}
